var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSobbing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 160,
    viewBox: "0 0 162 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.667 109.001C159.766 77.8995 149.218 43.1976 122.688 23.5334C96.1584 3.86909 59.8889 3.86909 33.3592 23.5334C6.82939 43.1976 -3.71856 77.8995 7.38034 109.001",
    stroke: "#F2FCEE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.667 105.001C163.766 73.8995 153.218 39.1976 126.688 19.5334C100.158 -0.130912 63.8889 -0.130912 37.3592 19.5334C10.8294 39.1976 0.281439 73.8995 11.3803 105.001",
    stroke: "#373737",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.169 60.0005C123.052 54.0055 117.384 49.9971 111.026 49.9971C104.668 49.9971 99.0007 54.0055 96.8828 60.0005",
    stroke: "#373737",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8726 60.0005C64.7547 54.0055 59.0873 49.9971 52.7293 49.9971C46.3712 49.9971 40.7039 54.0055 38.5859 60.0005",
    stroke: "#373737",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 105C72 99.4772 76.4772 95 82 95V95C87.5228 95 92 99.4772 92 105V115C92 120.523 87.5228 125 82 125V125C76.4772 125 72 120.523 72 115V105Z",
    stroke: "#373737",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85V135V135C23.7157 135 17 141.716 17 150C17 152.761 19.2386 155 22 155H62C64.7614 155 67 152.761 67 150C67 141.716 60.2843 135 52 135V85",
    stroke: "#228800",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112 85V135V135C103.716 135 97 141.716 97 150C97 152.761 99.2386 155 102 155H142C144.761 155 147 152.761 147 150C147 141.716 140.284 135 132 135V85",
    stroke: "#228800",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobbing);
export default __webpack_public_path__ + "assets/media/sobbing.d6c39772f8521c9f0087751dd44ea8ce.svg";
export { ForwardRef as ReactComponent };